import script from "./InformationInTheIntersection.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationInTheIntersection.vue?vue&type=script&lang=ts&setup=true"

import "./InformationInTheIntersection.vue?vue&type=style&index=0&id=4f4e72e9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4e72e9"]])

export default __exports__